import React, { useEffect, useState } from 'react';
import { Button, Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { SpinnerGif } from '../helpers/SpinnerGif';
import './Slider.css';
import { banners } from '../../config/config';
import { useTranslation } from 'react-i18next';

const country = process.env.REACT_APP_COUNTRY;

const Slider = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const [loaded, setLoaded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 450);
  const bannersGlobal = banners[country];

  const handleResize = () => {
    setIsMobile(window.innerWidth < 450);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Podés mantener este preload de la primera imagen para el spinner,
    // pero ya no hacemos lazy en las demás: todas llevan src real.
    const imageToPreload = new Image();
    imageToPreload.src = process.env.PUBLIC_URL + "banner/slider/banner_apc.webp";
    imageToPreload.onload = () => setLoaded(true);
    imageToPreload.onerror = () => setLoaded(true); // por las dudas no quedar colgado
  }, []);

  return (
    <div className='slider-container'>
      {!loaded ? (
        <SpinnerGif text="Solution Box" />
      ) : (
        <Carousel fade>
          {bannersGlobal.map((banner, index) => {
            const imgSrc = `${process.env.PUBLIC_URL}/${
              isMobile && banner.srcMob
                ? banner.srcMob
                : (currentLanguage === 'en' && banner.srcEn ? banner.srcEn : banner.src)
            }`;

            const Img = (
              <img
                className="d-block w-100 banner-image"
                src={imgSrc}                // ← sin lazy: siempre con src real
                alt={banner.alt}
                // Eliminamos data-src, loading y fetchpriority
              />
            );

            const linkHref = banner.linkMail && !banner.srcMARCA
              ? `mailto:${banner.linkMail}`
              : (banner.href || (banner.alt === "bnReXp2025" ? banner.href : `/marcas/${banner.srcMARCA}`));

            return (
              <Carousel.Item
                key={index}
                style={banner.alt === "BannerAmd2024" ? { justifyContent: "center", display: "flex" } : {}}
              >
                {banner.alt === "BannerAmd2024" && (
                  <Button
                    href="mailto:adrian_romero@solutionboxusa.com?subject=Solicitó información por AMD RYZEN 9000 Serie"
                    className='position-absolute BtnHomePageWebCat'
                    style={{ bottom: "80px" }}
                  >
                    Solicitar información
                  </Button>
                )}

                <a
                  href={linkHref}
                  aria-label={
                    banner.linkMail && !banner.srcMARCA
                      ? "Contactar por correo electrónico"
                      : `Ver productos de ${banner.alt || 'esta marca'}`
                  }
                >
                  {Img}
                </a>

                {banner.button && (
                  <div className="button-cont-slider">
                    <a
                      href={banner.button.link}
                      className="styled-button-slider"
                      aria-label={`${banner.button.text} - Abrir enlace`}
                    >
                      {banner.button.text}
                    </a>
                  </div>
                )}

                {banner.buttonLinkMarca && (
                  <div className="button-cont-slider-link-marca">
                    <a
                      href={banner.buttonLinkMarca.link}
                      className="styled-button-slider-link-marca text-uppercase"
                      aria-label={`${banner.buttonLinkMarca.text} - Ver más información`}
                    >
                      {banner.buttonLinkMarca.text}
                    </a>
                  </div>
                )}
              </Carousel.Item>
            );
          })}
        </Carousel>
      )}
    </div>
  );
};

export default Slider;
